import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { CtaSection } from './components/CtaSection';
import { Services } from './components/Services';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-crema font-sans text-dark selection:bg-eucalipto selection:text-white" data-id="element-0" data-mp="2mm2o6lf6l56l">
      <Hero data-id="element-1" data-mp="31b8l22qjqjbb" />
      <PainPoints data-id="element-2" data-mp="31ayvgg9eye65" />
      <CtaSection data-id="element-3" data-mp="31c9vc4zqn1rz" />
      <Services data-id="element-4" data-mp="31cte1nx7pu72" />
      <About data-id="element-5" data-mp="2wk09p15nonvi" />
      <Testimonials data-id="element-6" data-mp="2wka0gqyiyz29" />
      <Contact data-id="element-7" data-mp="2wjqkvgwckmre" />
      <Footer data-id="element-8" data-mp="2wj8evsjvuu6a" />
      <WhatsAppButton data-id="element-9" data-mp="2wip7v6vrtq71" />
    </div>;
}